import { createContext, useContext, useEffect, useState } from 'react';
import {
  getFingertipsLinks,
  getHealthSnapshot,
  getHealthSnapshotCoveredMembersHwDb,
  getOtherCompanyBenefits,
} from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type HwDbDashboardState = {
  healthSnapshot: Array<any>;
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  coveredFamilyMembers: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const HwDbDashboardStore = createContext<HwDbDashboardState>({
  healthSnapshot: [],
  fingertipLinks: [],
  companiesMessages: [],
  coveredFamilyMembers: [],
  otherCompanyBenefits: [],
});

const { Provider } = HwDbDashboardStore;

export const HwDbDashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [HwDbDashboardState, setHwDbDashboardState] =
    useState<HwDbDashboardState>({
      healthSnapshot: [],
      fingertipLinks: [],
      companiesMessages: [],
      coveredFamilyMembers: [],
      otherCompanyBenefits: [],
    });

  useEffect(() => {
    let healthSnapshot = getHealthSnapshot();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies('persona-hw');
    let coveredFamilyMembers = getHealthSnapshotCoveredMembersHwDb();
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setHwDbDashboardState({
      healthSnapshot,
      fingertipLinks,
      companiesMessages,
      coveredFamilyMembers,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={HwDbDashboardState}>{children}</Provider>;
};
